/*
 * @Author: 吴文洁
 * @Date: 2019-09-19 17:59:17
 * @LastEditors: liguokang
 * @LastEditTime: 2021-06-02 18:33:49
 * @Description:
 */
import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'underscore';
import moment from 'moment';
import { Cell, Popup, Picker, Progress } from 'mint-ui';
import VueLazyload from 'vue-lazyload';
import 'mint-ui/lib/style.css';
import 'wheat-ui/lib/wheat-ui.css';
import WheatUI from 'wheat-ui';
import vClickOutside from 'v-click-outside';
import Engine from '@/module/album/engine';
import { install as XMint } from './components';
import * as filters from './core/filters';
import WechatApi from './core/wechatApi';
import router from './router';
import User from './core/user';
import TransferDom from './directives/transfer-dom';

const VueTouch = require('vue-touch');

if (window.location.href.indexOf('res.xiaomai5.com') > 0) {
  const hm = document.createElement('script');
  if (window.location.href.indexOf('https://') >= 0) {
    hm.src =
      'https://jic.talkingdata.com/app/h5/v1?appid=F973977D1BA6460AB3426D6312648B5C&' + (VERSION ? 'vn=' + VERSION + '&vc=' + VERSION : 'vn=v1.0.0&vc=v1.0.0');
  } else {
    hm.src =
      'http://sdk.talkingdata.com/app/h5/v1?appid=F973977D1BA6460AB3426D6312648B5C&' + (VERSION ? 'vn=' + VERSION + '&vc=' + VERSION : 'vn=v1.0.0&vc=v1.0.0');
  }
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
}

const instId = window.getParameterByName('instId');
if (instId) {
  window.Cache.set('instId', instId); //用于区分是否来自第三方的公众号
}

const checkEnvironment = () => {
  if (location.host.indexOf('dev.xiaomai5') != -1) {
    return 'https://dev-api-upload.xiaomai5.com/';
  } else if (location.host.indexOf('rc.xiaomai5') != -1) {
    return 'https://rc-api-upload.xiaomai5.com/';
  } else {
    return 'https://api-upload.xiaomai5.com/';
  }
};

Engine.install(Vue);

try {
  window.linkStatus = localStorage.getItem('linkStatus');
} catch (error) {}

if (window.linkStatus) {
  window.drServer = 'https://api-c.xiaomai5.com/';
  window.UPLOAD = checkEnvironment();
} else {
  window.drServer = '';
  window.UPLOAD = checkEnvironment();
}

window._ = _;
window.Vue = Vue;
window.moment = moment;
window.CONTENT_TYPE = ['UNKNOWN', 'TEXT', 'PICTURE', 'VOICE', 'VIDEO', 'LESSON', 'COURSE', 'WORK'];

Vue.directive('transfer-dom', TransferDom);
Vue.use(VueLazyload);
Vue.use(XMint);
Vue.use(Vuex);
Vue.use(WheatUI);
Vue.use(vClickOutside);
Vue.component(Cell.name, Cell);
Vue.component(Picker.name, Picker);
Vue.component(Popup.name, Popup);
Vue.component(Progress.name, Progress);

Vue.use(VueTouch);

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

WechatApi.initShareConfig();
export default class AppConfig {
  static init() {
    Vue.config.devtools = true;
    Vue.config.silent = false;
  }
}

router.afterEach((to, from, next) => {
  updateDocumentTitle(to);
});

window.Nav = {
  title: '小麦校讯通',
};

function updateDocumentTitle(to) {
  if (to.meta.title) {
    if (to.meta.title === 'appname') {
      if (window.Cache.get('instId') && User.appId() != APPID) {
        if (window.Cache.get('instName')) {
          window.changeDocumentTitle(window.Cache.get('instName'));
        } else {
          //这里需要延迟一秒执行，以为有机构有两个小区，机构绑定的是a小区的instId，然后有用户只报名了b校区此时进入微信，标题会展示a校区的。但是如果用户进去登录页面有需要展示机构名称的
          setTimeout(() => {
            const params = {
              instId: window.Cache.get('instId'),
            };
            axios
              .post('customer/public/institution/detail', params)
              .then(res => {
                const data = res.result || {};
                const useName = data.nickName || data.instName;
                window.Cache.set('instName', useName);
                window.changeDocumentTitle(useName);
              })
              .catch(err => {});
          }, 1000);
        }
      } else {
        window.changeDocumentTitle(window.Nav.title);
      }
    } else {
      window.changeDocumentTitle(to.meta.title);
    }
  }
}



// WEBPACK FOOTER //
// ./src/AppConfig.js